module.exports = __webpack_public_path__ + "img/check_in.9a07e6ab.png";